import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import $ from 'jquery'

import {puzzleImages} from './../../../assets/img';
import RubberTemplates from "../../RubberPuzzleTemplates/RubberTemplates";

class DesignCanvas extends React.Component {
    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    }

    static defaultProps = {
        width: 400,
        height: 400,
    }

    state = {
        canvas: null,
        width: null,
        height: null,
        groupTop:0,
        groupLeft:0,
        rubberPuzzleType:'',
        showAlert:false,
        firstAlert:true, // added to show tooltip only once even if object is removed
    }

    componentDidUpdate() {
        if (this.props.isCanvasCleared) {
            const config = this.props.puzzle_config

            let grid = (this.props.width - 5) / config.width
            let unitScale = (this.props.width - 1) / config.width
            let canvasWidth = config.width * unitScale
            let canvasHeight = config.height * unitScale

            for (let i = 0; i <= config.width; i++) {
                this.props.canvas.add(
                    new window.fabric.Line([i * grid, 0, i * grid, canvasHeight], {
                        type: 'line',
                        stroke: '#716b6b',
                        selectable: false,
                    }),
                )
            }

            for (let i = 0; i <= config.height; i++) {
                this.props.canvas.add(
                    new window.fabric.Line([0, i * grid, canvasWidth, i * grid], {
                        type: 'line',
                        stroke: '#716b6b',
                        selectable: false,
                    }),
                )
            }
            this.props.clearCanvas()
        }
        const load_design = this.props.load_design
        const saved_id = this.props.saved_id
        if (load_design) {
            axios
                .post('/api/load_design', { id: saved_id })
                .then(res => {
                    let tempConfig = res.data
                    console.log(tempConfig);
                    let puzzle_config = tempConfig.puzzle_config,
                        rubber_puzzle_type = tempConfig.rubber_puzzle_type;
                    let config = puzzle_config
                    const unit = config.length_unit === "FEET"? 3.17 : 1;
                    this.props.setPuzzleConfig(puzzle_config);
                    this.props.setRubberPuzzleType(rubber_puzzle_type);

                    let length = config.width / 1 > config.height / 1 ? config.width : config.height
                    let grid = (this.props.width - 3) / +length
                    let unitScale = (this.props.width - 3) / +length
                    let canvasWidth = config.width * unitScale
                    let canvasHeight = config.height * unitScale
                    this.props.setCanvasGrid(grid)


                    let objectJson = tempConfig.json,
                        canvas_grid = tempConfig.canvas_grid;
                    let objs = null
                    this.props.canvas.setHeight(canvasHeight)
                    this.props.canvas.setWidth(canvasWidth)
                    this.props.setCanvasDimensions({width:canvasWidth, height:canvasHeight})
                    this.props.canvas.loadFromJSON(objectJson, () => {
                        this.props.canvas.getObjects('line').forEach(obj=>obj.set({selectable:false}))
                        this.props.canvas.renderAll()
                    },(obj)=>{
                        console.log(obj.type)
                        if(obj.type === 'line') obj.selectable=false;
                    })

                    // Initializing Undo and Redo buttons for saved designs
                    tempConfig.canvasState = []
                    tempConfig.currentStateIndex = 0
                    tempConfig.undoStatus = false
                    tempConfig.redoStatus = false
                    tempConfig.undoFinishedStatus = 1
                    tempConfig.redoFinishedStatus = 1
                    tempConfig.undoButton = ""
                    tempConfig.redoButton = ""

                    this.props.setCanvasGrid(canvas_grid)
                    this.props.setDisableLoad()
                })
        }
    }

    showPanel = (nav) => {
        if (nav === 'mySidenav5') return '#artwork.second-menu'
        if (nav === 'mySidenav6') return '#rubber-artwork.second-menu'
    }

    showEmptyZone = (width, area) => {
        const emptyArea = document.getElementById("second-custom-right");

        if (emptyArea) {
            setTimeout(() => {
                const panel = this.showPanel(area)

                panel && $(panel).show()
                emptyArea.style.display = 'block';
                emptyArea.style.width = `calc(100% - ${width}px)`;
            }, 300);
        }
    }

    componentDidMount() {
        const canvas = new window.fabric.Canvas('main-canvas')
        this.canvas = canvas;
        window.canvas = canvas;
        const t = new window.fabric.Text('', { fontFamily: 'Times New Roman' })
        canvas.add(t);
        let config = this.props.puzzle_config
        const unit = config.length_unit === "FEET"? 3.17 : 1;

        let length = null

        let grid = null
        if(this.props.canvas_grid) grid = this.props.canvas_grid;
        let unitScale = null
        let canvasWidth = 400
        let canvasHeight = 400

        if (!this.props.load_design) {
            const t = new window.fabric.Text('', { fontFamily: 'Times New Roman' })
            canvas.add(t)

            length = config.width / 1 > config.height / 1 ? config.width : config.height
            grid = (this.props.width - 3) / +length
            unitScale = (this.props.width - 3) / +length
            canvasWidth = config.width * unitScale
            canvasHeight = config.height * unitScale
            this.props.setCanvasGrid(grid)
            for (let i = 0; i <= config.width; i++) {
                canvas.add(
                    new window.fabric.Line([i * grid, 0, i * grid, canvasHeight], {
                        type: 'line',
                        stroke: '#716b6b',
                        selectable: false,
                    }),
                )
            }

            for (let i = 0; i <= config.height; i++) {
                canvas.add(
                    new window.fabric.Line([0, i * grid, canvasWidth, i * grid], {
                        type: 'line',
                        stroke: '#716b6b',
                        selectable: false,
                    }),
                )
            }

            this.updateDirectCanvasState(canvas)
        }

        this.props.setCanvas(canvas)
        this.props.setCanvasDimensions({width:canvas.getWidth(), height:canvas.getHeight()})

        canvas.on('rubber-puzzle:rotated',e => {
            let activeObject = this.props.canvas.getActiveObject();
            if(!activeObject) return;
            let mat_rubber_angle = activeObject.rubberAngle;
            activeObject._objects[0].rotate(mat_rubber_angle);
            canvas.renderAll();
        })

        canvas.on('object:moving', e => {
            console.log('here')
            if(!grid && this.props.canvas_grid) grid = this.props.canvas_grid;
            let activeObject = this.props.canvas.getActiveObject();
            if (activeObject &&
                (activeObject.__proto__.type === 'image' || activeObject.__proto__.type === 'group')
            ) {
                let unitRatio = this.props.puzzle_config.length_unit === "FEET"? 3.17 : 1;
                if(this.props.puzzle_config.type === 'rubber-puzzle') {
                    if(this.props.rubber_puzzle_type === 'inter-locking')
                        unitRatio = this.props.puzzle_config.length_unit === "FEET"? 1.96 : 1;
                    if(this.props.rubber_puzzle_type === 'straight')
                        unitRatio = this.props.puzzle_config.length_unit === "FEET"? 2 : 1;
                }
                activeObject.set({
                    left: Math.round(activeObject.left / grid / unitRatio) * grid * unitRatio,
                    top: Math.round(activeObject.top / grid/ unitRatio) * grid * unitRatio,
                });
                activeObject.setCoords();
            }
            let activeGroup = this.props.canvas.getActiveGroup();
            if(activeGroup){
                let group = activeGroup;
                let unitRatio = this.props.puzzle_config.length_unit === "FEET"? 3.17 : 1;
                if(this.props.puzzle_config.type === 'rubber-puzzle') {
                    if(this.props.rubber_puzzle_type === 'inter-locking')
                        unitRatio = this.props.puzzle_config.length_unit === "FEET"? 1.96 : 1;
                    if(this.props.rubber_puzzle_type === 'straight')
                        unitRatio = this.props.puzzle_config.length_unit === "FEET"? 2 : 1;
                }
                group.set({
                    left: Math.round(group.left / grid / unitRatio) * grid * unitRatio,
                    top: Math.round(group.top / grid/ unitRatio) * grid * unitRatio,
                })
            }
        })

        canvas.on('mouse:up', e=>{

            if(this.checkBrowser()){
                let activeObject = this.props.canvas.getActiveObject();
                if(activeObject){
                    $('.custom-main-content').css({overflow:'auto'});
                    this.setState({
                        isDragging:true,
                    })
                }
            }
            if(!this.checkBrowser()){
                return;
            }
            let activeObject = this.props.canvas.getActiveObject();
            if(activeObject){
                $(".second-menu").hide();
            }else{
                $(".second-menu").hide();
            }
            if (activeObject && activeObject.__proto__.type === 'image') {
                this.showEmptyZone(250, 'mySidenav5')
                $('.material-color-pane').css({ display: 'block' })
                document.getElementById("mySidenav5").style.width = "300px";
                let selectedColor = activeObject.get('fill')
                this.props.setSelectedMaterialColor(selectedColor)
            } else if(activeObject && activeObject.type === 'group') {
                let source = activeObject.getObjects()[0].getSrc();
                let matClass = activeObject.getObjects()[0].mat_class;
                this.props.setActiveRubberPuzzle({activeObject,matClass,source});
                document.getElementById("mySidenav5").style.width = "300px";
                return;
                let group = activeObject;
                group.set({
                    oldTop:group.top,
                    oldLeft:group.left,
                })
                $('.material-color-pane').css({ display: 'block' })
            }

        })
        canvas.on('object:selected', e => {
            this.props.tooltipHandler(false);
            let activeObject = this.props.canvas._activeObject;
            if(activeObject){
                activeObject.set({
                    oldTop:activeObject.top,
                    oldLeft:activeObject.left,
                })
            }
            if(this.props.puzzle_config.type === 'rubber-puzzle') {
                this.rubberPuzzleSelected();
                return;
            }
            if(this.checkBrowser()){
                return;
            }else{
                $(".second-menu").hide();
                $("#artwork").show();
                $(`#menu li.nav.active`).removeClass("active");
                $(`#menu li.nav.artworkedit`).addClass("active");
            }

            if (activeObject &&
                (activeObject.__proto__.type === 'text' ||
                    activeObject.__proto__.type === 'curvedText')
            ) {
                // add the delete button

                $('.second-menu').hide()
                $('#text').show()
                // font family
                let fontFamily = activeObject.get('fontFamily')
                $('.slct-font-fam').val(fontFamily)
                // font size
                let fontSize = activeObject.get('fontSize')
                $('.slct-font-size').val(`${fontSize}px`)
                // font weight
                let fontWeight = activeObject.get('fontWeight')
                if (fontWeight === 'bold') {
                    $('#bold').addClass('active')
                }
                // font style
                let fontStyle = activeObject.get('fontStyle')
                if (fontStyle === 'italic') {
                    $('#italic').addClass('active')
                }
                // text decoration
                let textDecoration = activeObject.get('textDecoration')
                if (textDecoration === 'underline') {
                    $('#underline').addClass('active')
                }
                // capital text
                let capitalText = activeObject.text
                if (capitalText === capitalText.toUpperCase()) {
                    $('#capital').addClass('active')
                }
                // text align
                let text_align = activeObject.get('textAlign')
                switch (text_align) {
                    case 'left':
                        $('#left-align').addClass('active')
                        break
                    case 'center':
                        $('#center-align').addClass('active')
                        break
                    case 'right':
                        $('#right-align').addClass('active')
                        break
                    default:
                        break
                }
                // line heigth
                let line_height = activeObject.get('lineHeight')
                $('#line_ht_get').val(Math.floor(line_height))
                $('#line_ht_set').val(Math.floor(line_height))
                $('#line_ht_get').css({
                    background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${(line_height /
                        10) *
                    10}%, #fff ${(line_height / 10) * 10}%, #fff 100%)`,
                })
                // spacing
                let spacing = activeObject.get('spacing')
                $('#spacing_get').val(spacing)
                $('#spacing_set').val(spacing)
                $('#spacing_get').css({
                    background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${(spacing /
                        10) *
                    10}%, #fff ${(spacing / 10) * 10}%, #fff 100%)`,
                })
                // text color
                let text_color = activeObject.get('fill')
                $('#text-color-bind').css({ background: text_color })
                // outline width
                let outline_width = activeObject.get('strokeWidth')
                $('#size_get').val(outline_width)
                $('#size_set').val(outline_width)
                $('#size_get').css({
                    background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${outline_width *
                    10}%, #fff ${outline_width * 10}%, #fff 100%)`,
                })
                // outline color
                let stroke_color = activeObject.get('stroke')
                $('#outline-color-bind').css({ background: stroke_color })
                // text style (arc)

                // selected text
                let selected_text = activeObject.text
                $('#selected_text').val(selected_text)
                $('.add-text-btn').text('Update Text')
            }
            else if (activeObject && activeObject.__proto__.type === 'image') {
                $('.material-color-pane').css({ display: 'block' })
                let selectedColor = activeObject.get('fill')
                this.props.setSelectedMaterialColor(selectedColor)
            }
            else if(e.target.type === 'group'){
                return;
                let group = e.target;
                group.set({
                    oldTop:group.top,
                    oldLeft:group.left,
                })
                $('.material-color-pane').css({ display: 'block' })
            }

        })
        canvas.on('selection:cleared', () => {
            $('.deleteBtn').css('visibility', 'hidden')
            $('.material-color-pane').css({ display: 'none' })
            $('.text-color-pane').css({ display: 'none' })

            $('#bold').removeClass('active')
            $('#italic').removeClass('active')
            $('#underline').removeClass('active')
            $('#capital').removeClass('active')
            $('#left-align').removeClass('active')
            $('#center-align').removeClass('active')
            $('#right-align').removeClass('active')
            $('.slct-font-size').val($('.slct-font-size option:first').val())
            $('.slct-font-fam').val($('.slct-font-fam option:first').val())
            $('#line_ht_get').val(1)
            $('#line_ht_get').css({
                background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
            })
            $('#line_ht_set').val(1)
            $('#spacing_get').val(1)
            $('#spacing_get').css({
                background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
            })
            $('#spacing_set').val(1)
            $('#text-color-bind').css({ background: 'black' })
            $('#size_get').val(0)
            $('#size_get').css({
                background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
            })
            $('#size_set').val(0)
            $('#outline-color-bind').css({ background: 'black' })
            $('#selected_text').val('sampletext')
            $('.add-text-btn').text('Add Text')

            if(!$(".artworkedit").hasClass('active')){
                $(".second-menu").hide();
                $("#mats").show();
                $(`#menu li.nav.active`).removeClass("active");
                $(`#menu li.nav.mats`).addClass("active");
            }
            if(this.checkBrowser()){
                document.getElementById("mySidenav1").style.width = "0px";
                document.getElementById("mySidenav2").style.width = "0px";
                document.getElementById("mySidenav5").style.width = "0px";
            }
        })
        canvas.on('object:added', (e) => {
            let lockRotation= this.props.puzzle_config.type === 'rubber-puzzle'
            if(e.target.type === 'rect'){
                e.target.set({stroke: '#9aa1a2' , strokeWidth: '1',lockScalingX:true,lockScalingY:true, lockRotation:lockRotation})
            }else{
                e.target.set({lockScalingX:true,lockScalingY:true, lockRotation:lockRotation})
            }

            if(this.canvas.getObjects('rect').length === 1 && this.state.firstAlert){
                this.props.tooltipHandler(true);
            }
            let object  = e.target;
            object.set({
                //transparentCorners: false,
                cornerStrokeColor: '#343131',
                borderColor: '#343131',
                cornerSize: 12,
                selectionDashArray: [5, 5],
            })
            if(object && object.type === "group"){
                this.checkRubberPuzzleType(object);
            }
            setTimeout(()=>{
                //this.updateCanvasState()
                this.props.canvas.renderAll();
            },100);
        })
        canvas.on('object:moving', e => {

        })
        canvas.on('object:rotating', (e)=>{
            let step = 90;
            let activeObject = e.target;
            if(this.props.puzzle_config.type === 'rubber-puzzle'){
                activeObject.set({angle:Math.round(activeObject.angle / step) * step})
            }
        });

        canvas.on('mouse:down',e=>{
            let activeGroup = this.props.canvas.getActiveGroup();
            if(activeGroup){
                this.setState({
                    groupTop:activeGroup.top,
                    groupLeft:activeGroup.left
                })
            }
            if(this.checkBrowser()){
                let activeObject = this.props.canvas.getActiveObject();
                if(activeObject){
                    $('.custom-main-content').css({overflow:'hidden'});
                    this.setState({
                        isDragging:true,
                    })
                }
            }
        })
        canvas.on('mouse:up',e=>{
            //code for group selection
            let activeObject = this.props.canvas.getActiveObject();
            let activeGroup = this.canvas.getActiveGroup();
            if(activeObject){
                let obj = e.target;
                let intersecting = this.findObjectsOnPoint(obj.left+10, obj.top+10 , obj.height-10 , obj.width-10 , obj);
                if(intersecting){
                    let oldTop = obj.oldTop;
                    let oldLeft= obj.oldLeft;
                    obj.set({
                        top:oldTop ,
                        left:oldLeft,
                        oldTop,
                        oldLeft
                    });
                    obj.setCoords();
                    this.canvas.renderAll();
                }else{
                    obj.set({
                        oldTop:obj.top,
                        oldLeft:obj.left,
                    });
                    obj.setCoords();
                    this.canvas.renderAll();
                }
            }
            else if(activeGroup){
                let intersects = false;
                activeGroup._objects.forEach(obj=>{
                    let intersecting = this.findObjectsOnGroup(obj , activeGroup);
                    if(intersecting){
                        intersects = true;
                    }
                })
                if(intersects){
                    activeGroup.set('top',this.state.groupTop);
                    activeGroup.set('left',this.state.groupLeft);
                }
                activeGroup.setCoords();
                this.props.canvas.renderAll();
            }
            //this.onIntersecting(e);
        })
        canvas.on('object:modified', e => {
            if (!this.props.load_design) this.updateCanvasState()
        })

        $('.mar').mousemove(e => {
            let canvas_grid = grid === null ? this.props.canvas_grid : grid
            const scrollTop = document.documentElement.scrollTop / 1
            if (this.props.drag_new_rect) {
                let width = $('#dragged_image').css('width')
                let height = $('#dragged_image').css('height')
                const top = e.pageY - height.replace('px', '') / 2 - scrollTop
                const left = e.pageX - width.replace('px', '') / 2
                $('#dragged_image').css({
                    position: 'fixed',
                    top: top,
                    left: left,
                })

                let position = $('.canvas-container').offset()

                let preview_top =
                    $('#dragged_image')
                        .css('top')
                        .replace('px', '') /
                    1 -
                    position.top;
                let preview_left =
                    $('#dragged_image')
                        .css('left')
                        .replace('px', '') /
                    1 -
                    position.left;

                if (
                    preview_top > -height.replace('px', '') / 2 - scrollTop &&
                    preview_top < (canvasHeight*this.props.zoom - height.replace('px', '') / 2 - scrollTop ) &&
                    preview_left > -width.replace('px', '') / 2 &&
                    preview_left < (canvasWidth*this.props.zoom - width.replace('px', '') / 2)
                ){
                    let unitRatio = this.props.puzzle_config.length_unit === "FEET"? 3.17 : 1;
                    if(this.props.puzzle_config.type === 'rubber-puzzle') {
                        if(this.props.rubber_puzzle_type === 'inter-locking')
                            unitRatio = this.props.puzzle_config.length_unit === "FEET"? 1.96 : 1;
                        if(this.props.rubber_puzzle_type === 'straight')
                            unitRatio = this.props.puzzle_config.length_unit === "FEET"? 2 : 1;
                    }

                    let finalTop = Math.round(((preview_top) + scrollTop) / canvas_grid / unitRatio / this.props.zoom) *
                        canvas_grid * unitRatio * this.props.zoom +
                        position.top -
                        scrollTop;
                    let finalLeft = Math.round((preview_left) / canvas_grid / unitRatio / this.props.zoom) *
                        canvas_grid * unitRatio * this.props.zoom +
                        position.left;
                    let intersect = this.onDragIntersection({
                        top:(finalTop - position.top+scrollTop)/this.props.zoom,
                        left:(finalLeft - position.left)/this.props.zoom,
                        width:$('#previewed_image').width()/this.props.zoom,
                        height:$('#previewed_image').height()/this.props.zoom,
                    });
                    if(!intersect){
                        finalTop+=10;
                        finalLeft+=10;
                        $('#previewed_image').css({filter: 'hue-rotate(238deg)'})
                    }else{
                        $('#previewed_image').css({filter: 'hue-rotate(0deg)'});
                    }
                    $('#previewed_image').css({
                        position: 'fixed',
                        display: 'block',
                        top:finalTop,
                        left:finalLeft,
                    })
                }else {
                    $('#previewed_image').css({
                        display: 'none',
                    })
                }
            }

            if (this.props.drag_new_template) {
                let width_template = $('#dragged_template').css('width')
                let height_template = $('#dragged_template').css('height')
                const top_template = e.pageY - height_template.replace('px', '') / 2 - scrollTop
                const left_template = e.pageX - width_template.replace('px', '') / 2
                $('#dragged_template').css({
                    position: 'fixed',
                    top: top_template,
                    left: left_template,
                })

                let position = $('.canvas-container').offset()

                let preview_top =
                    $('#dragged_template')
                        .css('top')
                        .replace('px', '') /
                    1 -
                    position.top
                let preview_left =
                    $('#dragged_template')
                        .css('left')
                        .replace('px', '') /
                    1 -
                    position.left

                if (
                    preview_top >= -height_template.replace('px', '') / 2 - scrollTop &&
                    preview_top <= (canvasHeight*this.props.zoom - height_template.replace('px', '') / 2) - scrollTop &&
                    preview_left >= -width_template.replace('px', '') / 2 &&
                    preview_left <= (canvasWidth*this.props.zoom - width_template.replace('px', '') / 2)
                ){
                    const unitPosition = config.length_unit === "FEET"? 3.17 : 1;
                    let finalTop = Math.round((preview_top + scrollTop) / grid / unitPosition / this.props.zoom) * grid * unitPosition * this.props.zoom +
                        position.top -
                        scrollTop;
                    let finalLeft = Math.round(preview_left / grid / unitPosition / this.props.zoom) * grid * unitPosition * this.props.zoom + position.left;
                    let intersect = this.onDragIntersection({
                        top:(finalTop-position.top+scrollTop)/this.props.zoom,
                        left:(finalLeft-position.left)/this.props.zoom,
                        width:$('#previewed_image').width()/this.props.zoom,
                        height:$('#previewed_image').height()/this.props.zoom,
                    },1);
                    if(!intersect){
                        $('#previewed_image').css({filter: 'hue-rotate(238deg)'})
                    }else{
                        $('#previewed_image').css({filter: 'hue-rotate(0deg)'})
                    }

                    $('#previewed_image').css({
                        position: 'fixed',
                        display: 'block',
                        top:finalTop,
                        left: finalLeft,
                    })
                }else {
                    $('#previewed_image').css({
                        display: 'none',
                    })
                }
            }
        })

        $('#drag_image').mousemove(e => {
            if (this.props.drag_new_rect) {
                let width = $('#dragged_image').css('width')
                let height = $('#dragged_image').css('height')
                const top = e.pageY - height.replace('px', '') / 2
                const left = e.pageX - width.replace('px', '') / 2
                $('#dragged_image').css({
                    position: 'fixed',
                    top: top,
                    left: left,
                })
            }
        })

        $('#drag_template').mousemove(e => {
            if (this.props.drag_new_template) {
                let width_template = $('#dragged_template').css('width')
                let height_template = $('#dragged_template').css('height')
                const top_template = e.pageY - height_template.replace('px', '') / 2
                const left_template = e.pageX - width_template.replace('px', '') / 2
                $('#dragged_template').css({
                    position: 'fixed',
                    top: top_template,
                    left: left_template,
                })
            }
        })

        $('#drag_image').mouseup((e) => {
            //e.preventDefault();
            //return;
            let hueRotate = $('#previewed_image').css('filter');
            if(hueRotate=== 'hue-rotate(238deg)'){
                this.props.setDragRect(false)
                $('#dragged_image').remove()
                $('#previewed_image').remove()
                return;
            }
            if (this.props.drag_new_rect) {
                let position = $('.canvas-container').offset()
                const scrollTop = document.documentElement.scrollTop / 1
                let data = {
                    top:
                        ($('#previewed_image')
                                .css('top')
                                .replace('px', '') /
                            1 -
                            position.top +
                            scrollTop)/this.props.zoom,
                    left:
                        ($('#previewed_image')
                                .css('left')
                                .replace('px', '') /
                            1 -
                            position.left)/this.props.zoom,
                }

                let width = $('#dragged_image').css('width')
                let height = $('#dragged_image').css('height')
                if (
                    data.top < (canvasHeight - height.replace('px', '') / 2) * this.props.zoom &&
                    data.top > -height.replace('px', '') / 2 &&
                    data.left >= -width.replace('px', '') / 2 &&
                    data.left <= (canvasWidth - width.replace('px', '') / 2)*this.props.zoom
                ) {
                    this.props.setMaterialPosition(data)
                    const rect = new window.fabric.Rect({
                        left: 0,
                        top: 0,
                        width: 50,
                        height: 50,
                        type: 'rectangle',
                        fill: '#fab',
                    })
                    this.props.addNewRect(rect)
                }

                this.props.setDragRect(false)
                $('#dragged_image').remove()
                $('#previewed_image').remove()
            }
        })

        $('#drag_template').mouseup(() => {
            const puzzle_config = this.props.puzzle_config;
            const mat_type = puzzle_config.type;
            let hueRotate = $('#previewed_image').css('filter');
            if(hueRotate=== 'hue-rotate(238deg)'){
                $('#dragged_template').remove()
                $('#previewed_image').remove()
                this.props.setDragTemplate(false)
                return;
            }
            if (this.props.drag_new_template) {
                const scrollTop = document.documentElement.scrollTop / 1
                let position = $('.canvas-container').offset()
                const data = {
                    top:
                        ($('#dragged_template')
                                .css('top')
                                .replace('px', '') /
                            1 -
                            position.top +
                            scrollTop)/this.props.zoom,
                    left:
                        ($('#dragged_template')
                                .css('left')
                                .replace('px', '') /
                            1 -
                            position.left)/this.props.zoom,
                }

                let width = $('#dragged_template').css('width')
                let height = $('#dragged_template').css('height')

                if (
                    data.top < (canvasHeight - height.replace('px', '') / 2)*this.props.zoom &&
                    data.top > -height.replace('px', '') / 2 &&
                    data.left >= -width.replace('px', '') / 2 &&
                    data.left <= (canvasWidth - width.replace('px', '') / 2)*this.props.zoom
                ) {
                    this.props.setTemplatePosition(data)
                    const template = {
                        type: this.props.template_type,
                    }
                    console.log(this.props.template_type)
                    if(mat_type === 'rubber-puzzle') this.addRubberTemplate(template.type,data)
                    else this.props.addNewTemplate(template);
                }

                $('#dragged_template').remove()
                $('#previewed_image').remove()
                this.props.setDragTemplate(false)
            }
        })
        $('#artwork').hide();
    }
    addRubberTemplate=(type,data)=>{
        console.log({type,data})
        const {canvas,canvas_grid,mat_type,puzzle_config} = this.props;
        console.log({puzzle_config});
        let designWidth = puzzle_config.width;
        let designHeight = puzzle_config.height;
        let puzzleTemplate = new RubberTemplates(canvas,canvas_grid,mat_type,data,puzzle_config);
        switch (type) {
            case 'templateRubber1':
                puzzleTemplate.addRubberTemplate1();
                return;
            case 'templateRubber2':
                puzzleTemplate.addRubberTemplate2();
                return;
            case 'templateRubber3':
                puzzleTemplate.addRubberTemplate3();
                return;
            case 'templateRubber4':
                puzzleTemplate.addRubberTemplate4();
                return;
            case 'templateRubber5':
                puzzleTemplate.addRubberTemplate5();
                return;
            case 'templateRubber6':
                puzzleTemplate.addRubberTemplate6();
                return;
        }
    }


    onDragIntersection=(r2)=>{
        let intersection = this.findObjectsOnPreview(0,0,0,0,r2);
        return !intersection;
    }

    findObjectsOnPreview=(minAx,minAy,maxAy,maxAx, obj)=>{
        let intersects = false;
        //detect collision
        let objects = this.canvas.getObjects('image');
        if(this.props.puzzle_config.type === 'rubber-puzzle')
            objects = this.canvas.getObjects('group');
        let ratio = obj.width-(obj.width*0.75)
        objects.forEach(item=>{
            let itemRight={
                top:item.top+ratio,
                left:item.left+ratio,
                width:item.width-ratio,
                height:item.height-ratio,
            };
            let objRight={
                top:obj.top+ratio,
                left:obj.left+ratio,
                width:obj.width-ratio,
                height:obj.height-ratio,
            }
            if(this.rectIntersect(itemRight,objRight) ){
                intersects = true;
                return;
            }
        })
        /*if(intersects){
          obj.set({fill:'red'});
        }else{
          obj.set({fill:'black'});
        }*/
        return intersects;
    }

    rubberPuzzleSelected=()=>{
        if(this.checkBrowser()){
            return;
        }
        let activeObject = this.props.canvas.getActiveObject();
        let activeSelection = this.props.canvas.getActiveGroup();
        if(activeObject && activeObject.type === 'group') {
            let source = activeObject.getObjects()[0].getSrc();
            let matClass = activeObject.getObjects()[0].mat_class;
            this.props.setActiveRubberPuzzle({activeObject,matClass,source});
        }
        else if(activeSelection) {
            activeSelection.name = 'activeSelection';
            let source = activeSelection.getObjects()[0].getObjects()[0].getSrc();
            let matClass = activeSelection.getObjects()[0].getObjects()[0].mat_class;
            this.props.setActiveRubberPuzzle({activeObject:activeSelection,matClass,source});
        }
        $(".second-menu").hide();
        $("#artwork").show();
        $(`#menu li.nav.active`).removeClass("active");
        $(`#menu li.nav.artworkedit`).addClass("active");
    }

    findObjectsOnGroup=(obj , groupObjects)=>{
        let intersects = false;
        let objects = this.canvas.getObjects('rect');
        objects.forEach(item=>{
            let self = false;
            if(item === obj){
                self = true;
            }
            //check if is member of group
            groupObjects._objects.forEach(groupItem=>{
                if(item === groupItem){
                    self = true;
                }
            })
            if(!self){
                let itemRight={
                    top:item.top+1,
                    left:item.left+1,
                    width:item.width-1,
                    height:item.height-1,
                };
                const absoluteLeft = obj.left + (groupObjects.width/2) + groupObjects.left;
                const absoluteTop = obj.top + (groupObjects.height/2) + groupObjects.top;
                let objRight={
                    top:absoluteTop+1,
                    left:absoluteLeft+1,
                    width:obj.width-1,
                    height:obj.height-1,
                }
                if(this.rectIntersect(itemRight,objRight) ){
                    intersects = true;
                    return;
                }
            }
        })
        return intersects;
    }
    findObjectsOnPoint=(minAx,minAy,maxAy,maxAx, obj)=>{
        let intersects = false;
        //detect collision
        let objects = this.canvas.getObjects('image');
        if(this.props.puzzle_config.type === 'rubber-puzzle')
            objects = this.canvas.getObjects('group');
        let ratio = obj.width-(obj.width*0.75)
        objects.forEach(item=>{
            if(item !== obj){
                let itemRight={
                    top:item.top+ratio,
                    left:item.left+ratio,
                    width:item.width-ratio,
                    height:item.height-ratio,
                };
                let objRight={
                    top:obj.top+ratio,
                    left:obj.left+ratio,
                    width:obj.width-ratio,
                    height:obj.height-ratio,
                }
                if(this.rectIntersect(itemRight,objRight) ){
                    intersects = true;
                    return;
                }
            }
        })
        return intersects;
    }

    rectIntersect=(r0, r1)=> {
        // reducing size of box to avoid boundries

        return this.rangeIntersect(r0.left, r0.left + r0.width, r1.left, r1.left + r1.width) && this.rangeIntersect(r0.top, r0.top + r0.height, r1.top, r1.top + r1.height);
    }
    rangeIntersect=(min0, max0, min1, max1)=> {
        return Math.max(min0, max0) >= Math.min(min1, max1) &&
            Math.min(min0, max0) <= Math.max(min1, max1);
    }


    updateDirectCanvasState = canvas => {
        let tempConfig = this.props._config
        if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
            let jsonData = canvas.toJSON()
            let canvasAsJson = JSON.stringify(jsonData)
            if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
                let indexToBeInserted = tempConfig.currentStateIndex + 1
                tempConfig.canvasState[indexToBeInserted] = canvasAsJson

                let numberOfElementsToRetain = indexToBeInserted + 1
                tempConfig.canvasState = tempConfig.canvasState.splice(
                    0,
                    numberOfElementsToRetain,
                )
            } else {
                tempConfig.canvasState.push(canvasAsJson)
            }

            tempConfig.currentStateIndex = tempConfig.canvasState.length - 1

            if (
                tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
                tempConfig.currentStateIndex !== -1
            ) {
                tempConfig.redoButton = 'disabled'
            }
        }
        this.props.setCanvasConfig(tempConfig)
    }

    updateCanvasState = () => {
        let tempConfig = this.props._config
        if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
            let jsonData = this.props.canvas.toJSON()
            let canvasAsJson = JSON.stringify(jsonData)
            if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
                let indexToBeInserted = tempConfig.currentStateIndex + 1
                tempConfig.canvasState[indexToBeInserted] = canvasAsJson

                let numberOfElementsToRetain = indexToBeInserted + 1
                tempConfig.canvasState = tempConfig.canvasState.splice(
                    0,
                    numberOfElementsToRetain,
                )
            } else {
                tempConfig.canvasState.push(canvasAsJson)
            }

            tempConfig.currentStateIndex = tempConfig.canvasState.length - 1

            if (
                tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
                tempConfig.currentStateIndex !== -1
            ) {
                tempConfig.redoButton = 'disabled'
            }
        }
        this.props.setCanvasConfig(tempConfig)
    }


    deleteSelectedText = () => {
        let activeObject = this.props.canvas._activeObject
        if (activeObject) {
            this.props.canvas.remove(activeObject)
            this.updateCanvasState()
        }
    }
    checkBrowser=()=>{
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    checkRubberPuzzleType=(object)=>{
        let rectType = object._objects.filter(obj=>obj.type==='image');

        let activeObject = object,
            grid = this.props.canvas_grid;
        if (activeObject &&
            (activeObject.__proto__.type === 'image' || activeObject.__proto__.type === 'group')
        ) {
            let unitRatio = this.props.puzzle_config.length_unit === "FEET"? 1.96 : 1;
            if(this.props.rubber_puzzle_type === 'straight')
                unitRatio = this.props.puzzle_config.length_unit === "FEET"? 2 : 1;
            activeObject.set({
                left: Math.round(activeObject.left / grid / unitRatio) * grid * unitRatio,
                top: Math.round(activeObject.top / grid/ unitRatio) * grid * unitRatio,
            });
            activeObject.setCoords();
        }
    }

    render() {
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                canvas: this.props.canvas,
            })
        });
        const puzzle_config = this.props.puzzle_config
        let length =
            puzzle_config.width / 1 > puzzle_config.height / 1
                ? puzzle_config.width
                : puzzle_config.height

        const grid = (this.props.width - 1) / +length
        const width = grid * puzzle_config.width
        const height = grid * puzzle_config.height

        return (
            <Fragment>
                <canvas id="main-canvas" title="Canvas Area" height={height} width={width} ></canvas>
                {this.props.canvas && children}
                <img
                    className="deleteBtn"
                    src={require('./../../../assets/img/delete.png')}
                    alt="delteBtn"
                    style={{
                        width: '20px',
                        height: '20px',
                        bottom: '0px',
                        position: 'absolute',
                        visibility: 'hidden',
                    }}
                    onClick={this.deleteSelectedText}
                />
            </Fragment>
        )
    }
}

const setCanvas = canvas => {
    return {
        type: 'SET_CANVAS',
        canvas: canvas,
    }
}

const setCanvasDimensions = dimensions =>{
    return{
        type:'SET_CANVAS_HEIGHT_WIDTH',
        dimensions
    }
}

const setActiveRubberPuzzle = (active_rubber_puzzle) =>{
    return{
        type:'SET_ACTIVE_PUZZLE',
        active_rubber_puzzle
    }
}

const setCanvasConfig = _config => {
    return {
        type: 'SET_CONFIG',
        _config,
    }
}

const setDragRect = drag_new_rect => {
    return {
        type: 'DRAG_NEW_RECT',
        drag_new_rect: drag_new_rect,
    }
}

const setDragTemplate = drag_new_template => {
    return {
        type: 'DRAG_NEW_TEMPLATE',
        drag_new_template: drag_new_template,
    }
}

const setDisableLoad = () => {
    return {
        type: 'DISABLE_DESIGN_LOAD',
    }
}

const setCanvasGrid = grid => {
    return {
        type: 'SET_CANVAS_GRID',
        grid: grid,
    }
}

const setMaterialPosition = data => {
    return {
        type: 'SET_MATERIAL_POSITION',
        data: data,
    }
}

const addNewRect = rect => {
    return {
        type: 'NEW_RECT',
        component: rect,
    }
}

const addNewTemplate = template => {
    return {
        type: 'NEW_TEMPLATE',
        component: template,
    }
}
const setSelectedMaterialColor = color => {
    return {
        type: 'SET_SELECTEED_MATERIAL_COLOR',
        color: color,
    }
}

const setTemplatePosition = data => {
    return {
        type: 'SET_TEMPLATE_POSITION',
        data: data,
    }
}

const clearCanvas = () => {
    return {
        type: 'CLAER_CANVAS',
        isCanvasCleared: false,
    }
}
const setPuzzleConfig = config => {

    return {
        type: 'SET_PUZZLE_CONFIG',
        _config: config,
    }
}
const setRubberPuzzleType =newType =>{
    return {
        type:"SET_ACTIVE_RUBBER_TYPE",
        rubber_puzzle_type:newType
    }
}

const mapStateToProps = state => {
    return {
        canvas: state.canvas,
        _config: state._config,
        load_design: state.load_design,
        saved_id: state.saved_id,
        puzzle_config: state.puzzle_config,
        drag_new_rect: state.drag_new_rect,
        mat_color: state.mat_color,
        mat_type: state.mat_type,
        canvas_grid: state.canvas_grid,
        template_type: state.template_type,
        drag_new_template: state.drag_new_template,
        templates_width: state.templates_width,
        isCanvasCleared: state.isCanvasCleared,
        zoom:state.zoom,
        rubber_puzzle_type: state.rubber_puzzle_type,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            setCanvasConfig,
            setDisableLoad,
            setCanvasGrid,
            setCanvas,
            setSelectedMaterialColor,
            setDragRect,
            setMaterialPosition,
            addNewRect,
            setTemplatePosition,
            addNewTemplate,
            setDragTemplate,
            clearCanvas,
            setCanvasDimensions,
            setActiveRubberPuzzle,
            setPuzzleConfig,
            setRubberPuzzleType
        },
        dispatch,
    )
}

const DesignCanvasState = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesignCanvas)

export default DesignCanvasState
